export const tableData = [
  {
    mode: 'Сухой',
    t1: 'до 60',
    t2: 'до 50',
    t3: 'до 40',
  },
  {
    mode: 'Нормальный',
    t1: 'свыше 60 до 75',
    t2: 'свыше 50 до 60',
    t3: 'свыше 40 до 50',
  },
  {
    mode: 'Влажный',
    t1: 'свыше  75',
    t2: 'свыше 60 до 75',
    t3: 'свыше 50 до 60',
  },
  {
    mode: 'Мокрый',
    t1: '—',
    t2: 'свыше 75',
    t3: 'свыше 60',
  },
]